import { Card, CardContent, Typography, Box, LinearProgress } from "@mui/material"
import { format } from "date-fns";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export const CadUpdateStatusCard = ({ cadTask }) => {
  if (!cadTask) return null;

  const { status, created_at, finished_at } = cadTask;

  const CustomCheckIcon = () => {
    return (
      <Box
        sx={{
          border: '2px solid #8BC34A',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CheckIcon sx={{ color: '#8BC34A' }} />
      </Box>
    );
  }

  const CustomCloseIcon = () => {
    return (
      <Box
        sx={{
          border: '2px solid #F44336',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CloseIcon sx={{ color: '#F44336' }} />
      </Box>
    );
  }

  const getStatusText = () => {
    switch (status) {
      case 'SUCCESS':
        return 'Concluído';
      case 'FAILED':
        return 'Erro ao enviar o arquivo';
      case 'PENDING':
        return 'Pendente';
      case 'STARTED':
        return 'Em progresso...';
      default:
        return status;
    }
  }

  const getStatusColor = () => {
    switch (status) {
      case 'SUCCESS':
        return '#88C54B';
      case 'FAILED':
        return '#E02E1A';
      case 'PENDING':
        return '#1583F4';
      case 'STARTED':
        return '#1583F4';
      default:
        return "black";
    }
  }

  const getIcon = () => {
    switch (status) {
      case 'SUCCESS':
        return <CustomCheckIcon />
      case 'FAILED':
        return <CustomCloseIcon />
      default:
        return null;
    }
  }

  const shouldBeDeterminate = status === 'SUCCESS' || status === 'FAILED';

  return (
    <Card variant="outlined" sx={{ borderRadius: "8px" }}>
      <CardContent sx={{ height: "100%" }}>
        <Typography
          variant="h5"
          sx={{
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 700
          }}
        >
          Status da Última Importação
        </Typography>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          justifyContent: "space-evenly",
          marginTop: "1rem",
          gap: 1,
        }}>
          <LinearProgress
            sx={{
              backgroundColor: 'white',
              '& .MuiLinearProgress-bar': {
                backgroundColor: status === "FAILED" ? "#EBEBEB" : getStatusColor(),
              },
              height: "12px",
              borderRadius: "8px",
              border: "1px solid #E0E0E0"
            }}
            variant={shouldBeDeterminate ? "determinate" : "indeterminate"}
            value={shouldBeDeterminate && 100}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 1,
            }}
          >
            {getIcon()}
            <Typography
              variant="body"
              fontWeight={700}
              color={getStatusColor()}
            >
              {getStatusText()}
            </Typography>
          </Box>
          <Box sx={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-start",
            gap: 5,
          }}>
            <Typography variant="body">
              <Typography fontWeight={400} fontSize="14px" color="#666666">
                Iniciado em:
                <span style={{ color: "black" }}>
                  {" "}{format(new Date(created_at), 'dd/MM/yyyy HH:mm')}
                </span>
              </Typography>
            </Typography>
            {
              finished_at &&
              <Typography variant="body" fontWeight={400} fontSize="14px" color="#666666">
                Finalizado em:
                <span style={{ color: "black" }}>{" "}{format(new Date(finished_at), 'dd/MM/yyyy HH:mm')}</span>
              </Typography>
            }
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
